import { sortBy } from 'lodash';

import type { Product } from 'api/products';

export function useDefaultHardwareBinding(product: Product | null | undefined) {
    if (!product?.hardwareBindings) return null;
    if (product.hardwareBindings.length < 1) return null;
    return sortBy(product.hardwareBindings, 'orderNumber')[0].id;
}
